import get from 'lodash/get'

export default trackingCtrl

/** @ngInject */
function trackingCtrl($scope, $state, Chart, Contract, AlertManager, PotManager, ReportManager, DeviceChecker, PrmUtilsService,
                      ErrorCatcher, userInfo, contractCons, userAction, landscapeQuestions) {
    $scope.data = { loading: true, graph: { data: null } }
    $scope.userInfo = userInfo
    $scope.userContract = userInfo.contractSelected
    $scope.userContract.isLinkyCommunicating = userInfo.contractSelected.prm.communicating
    $scope.userIsBase = userInfo.contractSelected && (userInfo.contractSelected.plan === 'Base')
    $scope.report = ReportManager
    $scope.pot = PotManager.getPotBalance()

    $scope.isMobile = DeviceChecker.isMobile

    $scope.isTab = DeviceChecker.isTab

    $scope.isSelectedContractHasPot = () => userInfo.contractSelected.providerOffer.has_pot

    PotManager.watch((newPot) => {
        $scope.pot = newPot
    })

    const activate = function () {
        if (!$scope.data) {
            $scope.data = { loading: true, graph: { data: null } }
        }

        if (contractCons && contractCons.length > 0) {
            const opts = {
                nextReadingDate: $scope.userContract.prm.next_reading_date,
                plan: $scope.userContract.plan,
            }
            $scope.data = {
                loading: false,
                graph: Chart.utils.generateGraphData(contractCons, opts),
            }
        } else {
            $scope.data = { loading: false, graph: { data: null } }
        }

        if (landscapeQuestions && landscapeQuestions.length) {
            $scope.landscapeQuestions = landscapeQuestions
        }
    }

    activate()
}



// WEBPACK FOOTER //
// ./src/states/tracking/tracking.js